import { Component, OnInit, ViewChild, Input, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ListsService } from '../../../../core/lists/lists.service';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';
import { ContentObserver } from '@angular/cdk/observers';

@Component({
  selector: 'app-offer-banner',
  templateUrl: './offer-banner.component.html',
  styleUrls: ['./offer-banner.component.scss'],

})
export class OfferBannerComponent implements OnInit, AfterViewInit {
  // configuration
  public imageUrl: any;
  public BrandList: any = [];

  storename = environment.storename;
  home = [];
  public config: SwiperConfigInterface = {};
  constructor(private listService: ListsService, public route: ActivatedRoute,
    public router: Router
  ) { }
  ngOnInit() {
    this.imageUrl = environment.imageUrl;
    // this.storename = environment.storename;

    this.BodySection(this.storename);
  }

  // function calls at finally
  ngAfterViewInit() {
    this.config = {
      slidesPerView: 3,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: true,
      preloadImages: false,
      lazy: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      speed: 500,
      effect: 'slide',
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 3
        },
        1400: {
          slidesPerView: 3
        },
        1500: {
          slidesPerView: 3
        },
        1920: {
          slidesPerView: 4
        },
        2560: {
          slidesPerView: 5
        }
      }
    };
  }


  // Body Section
  BodySection(id: any) {
    const params = {
      keyword: id,
      limit: ''
    };
    this.listService.BannerList(params).subscribe((res: any) => {
      console.log('Banner==>', res.data);
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].positioncontent === 1) {
          this.home.push(res.data[i]);
        }
      }
    });
  }

  // URL
  getInvoiceUrl(i) {
    console.log('url==>', i);
    this.router.navigate([i]);
  }
}
